<template>
  <section :aria-labelledby="`${panelId}-heading`">
    <div class="max-w-3xl">
      <h2
        :id="`${panelId}-heading`"
        class="text-2xl text-black dark:text-white"
      >
        {{ $t("pages.guide.tours") }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed text-grey dark:text-grey-light">
        {{ $t("pages.guide.bookIntro") }}
      </p>
    </div>

    <div v-if="cities.length > 1" class="mt-6">
      <p class="text-sm font-bold text-black dark:text-white">
        {{ $t("pages.guide.chooseCity") }}
      </p>
      <div
        class="mt-3 flex flex-wrap gap-2"
        role="group"
        :aria-label="$t('pages.guide.chooseCity')"
      >
        <button
          v-for="city in cities"
          :key="city.id"
          type="button"
          class="min-h-11 cursor-pointer rounded-md border px-4 py-2 text-sm font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black dark:focus-visible:outline-gold"
          :class="
            city.id === cityId
              ? 'border-black bg-black text-white dark:border-white dark:bg-white dark:text-black'
              : 'border-light-300 bg-white text-black hover:border-black dark:border-grey dark:bg-dark dark:text-white dark:hover:border-white'
          "
          :aria-pressed="city.id === cityId"
          @click="$emit('select-city', city.id)"
        >
          {{ city.name }}
        </button>
      </div>
    </div>

    <ToursBoard
      v-if="cityId"
      :key="cityId"
      class="mt-6"
      :city-id="cityId"
      :ignore-placement="true"
      :show-heading="false"
    />

    <GuideEmptyState
      v-else
      class="mt-6"
      icon="calendar"
      :title="$t('pages.guide.bookUnavailableTitle')"
      :description="$t('pages.guide.bookUnavailableDescription')"
    />
  </section>
</template>

<script lang="ts" setup>
import type { GuideBookCity } from "@/types";

defineProps<{
  cityId: number | null;
  cities: GuideBookCity[];
  panelId: string;
}>();

defineEmits<{
  "select-city": [cityId: number];
}>();
</script>
